import { StateInterface, SnackbarInterface } from "./state";
import { getInstance } from "shared/i18n";

const snackbarDefaults = {
  visible: true,
  text: "",
  timeout: 6000
};

export default {
  defaultError(state: StateInterface): void {
    state.snackbar = {
      ...snackbarDefaults,
      text: getInstance()
        .t("global.errors.default")
        .toString(),
      color: "error"
    };
  },
  setSnackbar(state: StateInterface, payload: SnackbarInterface): void {
    state.snackbar = { ...snackbarDefaults, ...payload };
  },
  setSnackbarVisibility(state: StateInterface, payload: boolean): void {
    state.snackbar.visible = payload;
  }
};
